export interface ArticleItem {
    image: string
    title: string
    text: string
    date?: string
    href: string
}

export const indexArticles: ArticleItem[] = [
    {
        image: '/images/index-page/articles/article-placeholder.jpg',
        title: 'Лайфхаки для успешного продвижения на маркетплейсах в ноябре 2024 года',
        text: 'Ноябрь — это время активных распродаж. Покупатели ищут лучшие предложения, а продавцы стараются привлечь как можно больше внимания.',
        date: '20.11.2024',
        href: '/',
    },
    {
        image: '/images/index-page/articles/article-placeholder.jpg',
        title: 'Как увеличить конверсию на маркетплейсах в 2024 году?',
        text: 'Высокая конверсия карточек товара — это ключ к успеху на маркетплейсах. Ваша задача — сделать так, чтобы клиент, увидев ваш товар, захотел его купить, а не ушёл к конкуренту.',
        date: '20.11.2024',
        href: '/',
    },
    {
        image: '/images/index-page/articles/article-placeholder.jpg',
        title: 'Тренды продвижения на маркетплейсах в 2024 году',
        text: 'Современные маркетплейсы в 2024 году продолжают активно развиваться, и конкуренция на них растёт с каждым месяцем. Если вы хотите оставаться в лидерах или пробиться в топ, важно быть в курсе трендов, которые задают тон индустрии.',
        date: '20.11.2024',
        href: '/',
    }
]
